// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"b803b670","683":"8ce6403c","863":"74a3215b","937":"1cedf4f9"}[chunkId] + ".chunk.js";
};